import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import Email from './Email'
import Name from './Name'
import LanguageSwitcher from 'components/Shared/LanguageSwitcher'
import MultiLoginSwitcher from './MultiClientLogin'
import { deleteUserProfile } from 'api/auth'
import ConfirmationModal from 'components/Shared/ConfirmationModal'
import PortalModal from 'components/Shared/PortalModal'
import { useToast } from 'components/Shared/AppToast/ToastProvider'
import { useTranslation } from 'react-i18next'
import { hasMultiplePartners } from 'utils/cognitoGroups'

export default function PersonalSettings({ setDeleteAccountModalOpen, deleteAccountModalOpen }) {
  const [isDeleting, setIsDeleting] = useState(false)
  const user = useSelector((state) => state.user)
  const { addNotification } = useToast()
  const { t } = useTranslation()

  const handleDeleteUserProfile = async () => {
    setIsDeleting(true)
    const result = await deleteUserProfile()
    setIsDeleting(false)
    if (result.success) {
      console.log('User profile deleted')
    } else {
      addNotification({
        message: t('Settings.deleteAccount.modal.errorTitle'),
        description: t('Settings.deleteAccount.modal.errorDescription'),
        variant: 'error',
      })
    }
  }

  return (
    <>
      <div className="settings-page__section">
        <Email />
      </div>
      <Name />
      <div className="settings-page__section" style={{ overflow: 'visible' }}>
        <LanguageSwitcher settings />
      </div>
      {
        //Only show MultiLoginSwitcher when there are multiple partners available for user
        hasMultiplePartners(user) ? (
          <div className="settings-page__section">
            <MultiLoginSwitcher />
          </div>
        ) : null
      }

      <PortalModal isOpen={deleteAccountModalOpen} onClickOutside={() => setDeleteAccountModalOpen(false)}>
        <ConfirmationModal
          title={t('Settings.deleteAccount.modal.title')}
          description={t('Settings.deleteAccount.modal.description')}
          onCancel={() => setDeleteAccountModalOpen(false)}
          onConfirm={handleDeleteUserProfile}
          confirmText={t('Settings.deleteAccount.modal.buttonDelete')}
          isLoading={isDeleting}
        />
      </PortalModal>
    </>
  )
}
